export default __webpack_public_path__ + "static/media/RedHatDisplay-Medium.7ee466f5.ttf";